var exports = {
  "wx": "header__PdxDf4",
  "k4": "columnHeader__b5j9Mx",
  "fi": "column__876Stu",
  "Cd": "leftColumn__s8w2Nk",
  "DK": "rightColumn__0vugUr",
  "Lz": "slimLineTopTabs__dfTHw9",
};

module.exports = exports;
